import { Component } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { AmchartsReact } from "amchart4-react";
am4core.addLicense("ch-custom-attribution");

function am4themes_myThemePieChart(target) {
  if (target instanceof am4core.ColorSet) {
    target.list = [am4core.color("#120078"), am4core.color("#fd3a69"), am4core.color("#17c973"), am4core.color("#892cdc"), am4core.color("#fecd1a"), am4core.color("#9d0191")];
  }
}
am4core.useTheme(am4themes_myThemePieChart);
class NewPieChart extends Component {
  state = {
    chart: null,
  };

  componentDidMount() {
    const chart = am4core.create("newpiechartdiv" + this.props.id, am4charts.PieChart);
    this.createChart(chart);
  }

  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
  createChart = (chart) => {
    chart.data = this.props.piegraphData;
    chart.numberFormatter = new am4core.NumberFormatter();
    chart.numberFormatter.numberFormat = "#.##a"; //formats from 1e+9 into B instead of G
    chart.numberFormatter.smallNumberThreshold = 0.0001;
    chart.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "B" },
      { number: 1e12, suffix: "T" },
    ];
    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "key";
    if (!this.props.disabaleClick) {
      pieSeries.slices.template.tooltipText = this.props.label ? "{value} " + this.props.label + ",\n{key}: {marketShare}%" : "{value},\n{key}: {marketShare}%" + ":\n " + "-----------------------\n" + "Click to Apply Filter";
    } else {
      pieSeries.slices.template.tooltipText = this.props.label ? "{value} " + this.props.label + ",\n{key}: {marketShare}%" : "{value},\n{key}: {marketShare}%";
    }
    pieSeries.tooltip.label.maxWidth = 550;
    pieSeries.tooltip.label.wrap = true;
    chart.tooltip.label.fontSize = 25;
    // Let's cut a hole in our Pie chart the size of 30% the radius
    chart.innerRadius = 30;
    chart.height = am4core.percent(80);
    // Put a thick white border around each Slice
    pieSeries.slices.template.stroke = am4core.color("#fff");
    pieSeries.slices.template.strokeWidth = 2;
    pieSeries.slices.template.strokeOpacity = 1;
    if (!this.props.disabaleClick) {
      pieSeries.slices.template.events.on(
        "hit",
        (ev) => {
          let item = ev.target._dataItem._dataContext;
          this.props.mapClickedFilterKey(!!this.props && !!this.props.analyticsFieldKeys && this.props.analyticsFieldKeys !== "" ? this.props.analyticsFieldKeys : "", item.filterKey ? item.filterKey : item.key);
        },
        this
      );
    }
    // change the cursor on hover to make it apparent the object can be interacted with
    pieSeries.slices.template.cursorOverStyle = this.props.disabaleClick
      ? am4core.MouseCursorStyle.default
      : [
          {
            property: "cursor",
            value: "pointer",
          },
        ];

    pieSeries.alignLabels = false;
    pieSeries.labels.template.bent = false;
    pieSeries.labels.template.radius = 3;
    pieSeries.labels.template.padding(0, 0, 0, 0);
    pieSeries.labels.template.fontSize = 12;
    pieSeries.labels.template.disabled = true;
    pieSeries.ticks.template.disabled = true;

    // Create a base filter effect (as if it's not there) for the hover to return to
    let shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter());
    shadow.opacity = 0;

    // Create hover state
    let hoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

    // Slightly shift the shadow and make it more prominent on hover
    let hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter());
    hoverShadow.opacity = 0.7;
    hoverShadow.blur = 5;

    // Add a legend
    chart.legend = new am4charts.Legend();
    chart.cursor = new am4charts.XYCursor();
    if (!this.props.disabaleClick) {
      chart.legend.itemContainers.template.events.on(
        "hit",
        (ev) => {
          let item = ev.target._dataItem._dataContext._dataContext;
          this.props.mapClickedFilterKey(!!this.props && !!this.props.analyticsFieldKeys && this.props.analyticsFieldKeys !== "" ? this.props.analyticsFieldKeys : "", item.key);
        },
        this
      );
    }
    chart.legend.fontSize = "10px";
    chart.legend.labels.template.minWidth = 100;
    chart.legend.labels.template.maxWidth = 100;
    chart.legend.labels.template.truncate = true;
    chart.legend.labels.template.text = !this.props.disabaleClick ? "{key}" : "{legendKey}";
    chart.legend.valueLabels.template.text = "{marketShare}%";
    chart.legend.align = "right"; //added for right allign of labels
    chart.legend.position = "right"; //added for right allign of labels
  };

  render() {
    return (
      <div className="w-100">
        <div id={"newpiechartdiv" + this.props.id} style={{ width: "100%", height: "420px" }} />
        {this.state.chart ? <AmchartsReact chart={this.state.chart} color={am4core.color("#838383")} /> : null}
      </div>
    );
  }
}

export default NewPieChart;
